import PropTypes from 'prop-types';
import React from 'react';
import { Spinner } from 'common/spinners';
import EmptyTable from 'src/common/tables/EmptyTable/EmptyTable';
import {
  ColumnHeader,
  SortableColumnHeader,
  DataCell,
  DataRow,
  HeaderRow,
  Table,
  TableBody,
} from 'src/common/tables/V2';
import formatLongDate from 'src/common/utils/Dates/formatLongDate';
import _, { noop, intersection } from 'lodash';
import { Checkbox } from 'src/common/TailwindComponents';
import SelectAllCheckboxColumnHeader from '../../../../common/Workqueue/SelectAllCheckboxColumnHeader';

export function ExternalScreeningsTable(props) {
  const {
    screenings,
    isFetching,
    sortDirection,
    sortBy,
    setSort,
    paging,
    onCellClick,
    onCheckAssign,
    selectedRows,
    toggleSelectedRow,
    toggleSelectAllRows,
    assigningScreens,
  } = props;

  const selectedScreeningsIds = selectedRows.map((row) => row.id);
  const assignedScreensIds = screenings.filter((screen) => screen.assigned_to_id).map((screen) => screen.id);

  const allRowsOnCurrentPageSelected = intersection(
    selectedScreeningsIds,
    screenings.map((val) => val.id),
  ).length === screenings.length;

  return (
    <div className="dashboard-inner-content">
      {isFetching && _.isEmpty(screenings) ? (
        <Spinner />
      ) : (
        <div className="pt-1">
          <Table
            id="external-screenings-table"
            className="bg-white rounded-t-lg border border-solid border-light-border-blue"
          >
            <HeaderRow>
              <SelectAllCheckboxColumnHeader
                isChecked={allRowsOnCurrentPageSelected}
                onCheckColumn={() => toggleSelectAllRows()}
                ariaLabel="Select all screenings to assign"
              />
              <ColumnHeader className="w-1/6">Client Name</ColumnHeader>
              <SortableColumnHeader
                colName="type"
                className="w-1/6"
                label="Screening Type"
                sortBy={sortBy}
                sortDirection={sortDirection}
                setSort={setSort}
              >
                Screening Type
              </SortableColumnHeader>
              <SortableColumnHeader
                colName="source"
                className="w-1/6"
                label="Submitter"
                sortBy={sortBy}
                sortDirection={sortDirection}
                setSort={setSort}
              >
                Submitter
              </SortableColumnHeader>
              <ColumnHeader className="w-1/12">Organization</ColumnHeader>
              <SortableColumnHeader
                colName="identified_needs_count"
                className="w-1/12"
                label="Needs Identified"
                sortBy={sortBy}
                sortDirection={sortDirection}
                setSort={setSort}
              >
                Needs Identified
              </SortableColumnHeader>
              <SortableColumnHeader
                colName="created_at"
                className="w-1/12"
                label="Date Received"
                sortBy={sortBy}
                sortDirection={sortDirection}
                setSort={setSort}
              >
                Date Received
              </SortableColumnHeader>
              <SortableColumnHeader
                colName="assigned_to_id"
                className="w-1/12"
                label="Assignment Status"
                sortBy={sortBy}
                sortDirection={sortDirection}
                setSort={setSort}
              >
                Assignment Status
              </SortableColumnHeader>
              <ColumnHeader className="w-1/12">Mark as Assigned</ColumnHeader>
            </HeaderRow>
            <TableBody>
              {screenings.map((screen) => (
                <DataRow
                  className="cursor-pointer hover:bg-light-fill-blue hover:bg-opacity-50"
                  key={`screen-row-${screen.id}`}
                  onClick={() => onCellClick(screen)}
                >
                  <DataCell className="w-1/6">
                    <Checkbox
                      id={`select-screen-checkbox-${screen.id}`}
                      ariaLabel={`Select screen ${screen.id}`}
                      className="select-enrollment-request-checkbox"
                      checked={selectedScreeningsIds.includes(screen.id)}
                      onClick={(e) => e.stopPropagation()}
                      onChange={() => toggleSelectedRow(screen)}
                    />
                  </DataCell>
                  <DataCell className="w-1/6">{screen.client_name}</DataCell>
                  <DataCell className="w-1/6">{screen.type}</DataCell>
                  <DataCell className="w-1/6">{screen.submitter_name}</DataCell>
                  <DataCell className="w-1/6">{screen.organization_name}</DataCell>
                  <DataCell className="w-1/12">{screen.identified_needs_count}</DataCell>
                  <DataCell className="w-1/12">{formatLongDate(screen.created_at)}</DataCell>
                  <DataCell className="w-1/12">{screen.assigned}</DataCell>
                  <DataCell className="w-1/12">
                    <Checkbox
                      className="phone-field__is-primary"
                      id={`cb-${screen.id}`}
                      inline
                      inputStyle={{ marginRight: '0' }}
                      onClick={(e) => e.stopPropagation()}
                      onChange={() => onCheckAssign(screen.id, !assignedScreensIds.includes(screen.id))}
                      checked={assignedScreensIds.includes(screen.id)}
                      disabled={assigningScreens[screen.id]}
                      style={{
                        fontSize: '13px',
                      }}
                    />
                  </DataCell>
                </DataRow>
              ))}
            </TableBody>
          </Table>
          {paging.total_count === 0 && (
            <EmptyTable
              className={
                'p-6 border border-t-0 border-solid border-light-border-blue'
              }
              message={'No Results Found.'}
            />
          )}
        </div>
      )}
    </div>
  );
}

ExternalScreeningsTable.propTypes = {
  sortBy: PropTypes.string.isRequired,
  screenings: PropTypes.array.isRequired,
  sortDirection: PropTypes.string.isRequired,
  isFetching: PropTypes.bool.isRequired,
  setSort: PropTypes.func.isRequired,
  paging: PropTypes.shape({
    total_count: PropTypes.number.isRequired,
  }).isRequired,
  onCellClick: PropTypes.func.isRequired,
  onCheckAssign: PropTypes.func.isRequired,
  selectedRows: PropTypes.array,
  toggleSelectedRow: PropTypes.func,
  toggleSelectAllRows: PropTypes.func,
  assigningScreens: PropTypes.func.isRequired,
};

ExternalScreeningsTable.defaultProps = {
  selectedRows: [],
  toggleSelectAllRows: noop,
  toggleSelectedRow: noop,
};

export default ExternalScreeningsTable;
